<template>
  <div class="independent-wrapper">
    <div class="content">
      <div class="title">
        <span class="border"></span>
        <i class="el-icon-location-outline"></i> 商城管理 > 代理邀请
      </div>

      <div class="contentLeft">
        <div class="con">
          <!-- 生成表单 -->
          <div class="form-card">
            <div class="form-row">
              <span class="form-label">城市编码</span>
              <el-input v-model="form.cityCode" placeholder="如 330100" maxlength="32" style="width: 200px;" />
              <span class="form-label">城市名称</span>
              <el-input v-model="form.cityName" placeholder="如 杭州市" maxlength="64" style="width: 200px;" />
              <span class="form-label">目标角色</span>
              <el-select v-model="form.targetRole" style="width: 140px;">
                <el-option label="城市代理" :value="1"></el-option>
              </el-select>
            </div>
            <div class="form-row">
              <span class="form-label">小程序版本</span>
              <el-select v-model="form.envVersion" style="width: 140px;">
                <el-option label="正式版" value="release"></el-option>
                <el-option label="体验版" value="trial"></el-option>
                <el-option label="开发版" value="develop"></el-option>
              </el-select>
              <span class="form-label">备注</span>
              <el-input v-model="form.remark" placeholder="选填，便于识别" maxlength="255" style="width: 380px;" />
              <el-button type="primary" :loading="creating" @click="handleCreate" style="margin-left: 16px;">
                生成邀请码
              </el-button>
              <el-button @click="resetForm">重置</el-button>
            </div>
            <div class="form-tip">
              小程序版本说明：<b>正式版</b>需小程序已发布上线方可识别；<b>体验版</b>仅微信开发者后台「体验成员」可识别；<b>开发版</b>仅开发者工具内可识别。
            </div>
          </div>

          <!-- 历史列表 -->
          <div class="table-con consiliaTable">
            <el-table
              :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
              tooltip-effect="dark"
              style="width: 100%"
              :data="tableData"
              v-loading="loading"
            >
              <el-table-column align="center" label="ID" prop="id" width="60"></el-table-column>
              <el-table-column align="center" label="邀请码" prop="inviteCode" width="160">
                <template #default="{ row }">
                  <span style="font-family: monospace; color: #1D7268; font-weight: 600;">{{ row.inviteCode }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="目标角色" prop="targetRole" width="100">
                <template #default="{ row }">
                  <el-tag :type="roleTagType(row.targetRole)" size="small">{{ roleName(row.targetRole) }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="城市编码" prop="cityCode" width="100"></el-table-column>
              <el-table-column align="center" label="城市名称" prop="cityName" width="120"></el-table-column>
              <el-table-column align="center" label="使用次数" prop="useCount" width="90">
                <template #default="{ row }">{{ row.useCount || 0 }}</template>
              </el-table-column>
              <el-table-column align="center" label="状态" width="80">
                <template #default="{ row }">
                  <span :style="{ color: row.status === 1 ? '#67c23a' : '#f56c6c' }">
                    {{ row.status === 1 ? '可用' : '停用' }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="备注" prop="remark" min-width="160">
                <template #default="{ row }">{{ row.remark || '-' }}</template>
              </el-table-column>
              <el-table-column align="center" label="创建时间" prop="createdTime" width="160"></el-table-column>
              <el-table-column align="center" label="操作" width="160">
                <template #default="{ row }">
                  <span class="editor" @click="copyCode(row.inviteCode)">复制码</span>
                  <span class="editor" @click="loadQrcode(row)">查看二维码</span>
                </template>
              </el-table-column>
            </el-table>

            <div class="pagination-wrap">
              <el-pagination
                background
                layout="total, prev, pager, next"
                :total="total"
                :current-page="query.pageNum"
                :page-size="query.pageSize"
                @current-change="handlePageChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 邀请码 + 二维码弹窗 -->
    <el-dialog title="邀请码与小程序码" v-model="qrVisible" width="440px" center>
      <div class="qr-modal" v-loading="qrLoading">
        <div class="qr-row">
          <span class="qr-label">邀请码</span>
          <span class="qr-code" @click="copyCode(qrInfo.inviteCode)">
            {{ qrInfo.inviteCode || '-' }}
            <i class="el-icon-document-copy" style="margin-left: 6px;"></i>
          </span>
        </div>
        <div class="qr-row" v-if="qrInfo.cityName">
          <span class="qr-label">城市</span>
          <span>{{ qrInfo.cityName }}（{{ qrInfo.cityCode }}）</span>
        </div>
        <div class="qr-row">
          <span class="qr-label">版本</span>
          <el-select v-model="qrInfo.envVersion" size="small" style="width: 140px;"
                     :disabled="qrLoading || !qrInfo.inviteCode"
                     @change="regenerateQr">
            <el-option label="正式版" value="release"></el-option>
            <el-option label="体验版" value="trial"></el-option>
            <el-option label="开发版" value="develop"></el-option>
          </el-select>
          <span class="qr-env-tip">{{ envTip(qrInfo.envVersion) }}</span>
        </div>
        <div class="qr-img-wrap">
          <img v-if="qrInfo.qrcode" :src="qrInfo.qrcode" class="qr-img" alt="小程序码" />
          <div v-else class="qr-placeholder">
            <span>{{ qrInfo.qrcodeError || '小程序码未生成' }}</span>
          </div>
        </div>
        <div class="qr-actions">
          <el-button v-if="qrInfo.qrcode" type="primary" @click="downloadQr">下载图片</el-button>
          <el-button @click="qrVisible = false">关闭</el-button>
        </div>
        <div v-if="qrInfo.qrcodeError" class="qr-error-tip">
          {{ qrInfo.qrcodeError }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axiosconf from '../../api/axiosconf'

export default {
  data() {
    return {
      loading: false,
      creating: false,
      tableData: [],
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 10
      },
      form: {
        cityCode: '',
        cityName: '',
        targetRole: 1,
        remark: '',
        envVersion: 'release'
      },
      qrVisible: false,
      qrLoading: false,
      qrInfo: {
        inviteCode: '',
        cityCode: '',
        cityName: '',
        qrcode: '',
        qrcodeError: '',
        envVersion: 'release'
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    roleName(r) {
      return ({ 1: '城市代理', 2: '区县代理', 3: '经销商' })[r] || '-'
    },
    roleTagType(r) {
      return ({ 1: 'danger', 2: 'warning', 3: '' })[r] || 'info'
    },
    handlePageChange(p) {
      this.query.pageNum = p
      this.fetchList()
    },
    resetForm() {
      this.form.cityCode = ''
      this.form.cityName = ''
      this.form.targetRole = 1
      this.form.remark = ''
      this.form.envVersion = 'release'
    },
    envTip(env) {
      return ({
        release: '需小程序已发布',
        trial: '仅体验成员可识别',
        develop: '仅开发者工具内'
      })[env] || ''
    },
    async fetchList() {
      this.loading = true
      try {
        const res = await axiosconf.applicationJsonGet('/mall/admin/invite/list', this.query)
        if (res.data && res.data.code === 0) {
          const data = res.data.data || {}
          this.tableData = data.records || []
          this.total = data.total || 0
        } else {
          this.$message.error((res.data && res.data.msg) || '加载失败')
        }
      } catch (e) {
        console.error('加载邀请列表失败', e)
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    async handleCreate() {
      if (!this.form.cityCode || !this.form.cityCode.trim()) {
        return this.$message.warning('请输入城市编码')
      }
      if (!this.form.cityName || !this.form.cityName.trim()) {
        return this.$message.warning('请输入城市名称')
      }
      this.creating = true
      try {
        const payload = {
          cityCode: this.form.cityCode.trim(),
          cityName: this.form.cityName.trim(),
          targetRole: this.form.targetRole,
          remark: this.form.remark ? this.form.remark.trim() : undefined,
          envVersion: this.form.envVersion
        }
        const res = await axiosconf.applicationJson('/mall/admin/invite/create', payload)
        if (res.data && res.data.code === 0) {
          const data = res.data.data || {}
          this.qrInfo = {
            inviteCode: data.inviteCode || '',
            cityCode: this.form.cityCode,
            cityName: this.form.cityName,
            qrcode: data.qrcode || '',
            qrcodeError: data.qrcodeError || '',
            envVersion: data.envVersion || this.form.envVersion
          }
          this.qrVisible = true
          this.$message.success('邀请码已生成')
          this.fetchList()
        } else {
          this.$message.error((res.data && res.data.msg) || '生成失败')
        }
      } catch (e) {
        console.error('生成邀请码失败', e)
        this.$message.error('生成失败')
      } finally {
        this.creating = false
      }
    },
    async loadQrcode(row) {
      this.qrInfo = {
        inviteCode: row.inviteCode,
        cityCode: row.cityCode,
        cityName: row.cityName,
        qrcode: '',
        qrcodeError: '',
        envVersion: 'release'
      }
      this.qrVisible = true
      await this.fetchQrcode()
    },
    async regenerateQr() {
      if (!this.qrInfo.inviteCode) return
      await this.fetchQrcode()
    },
    async fetchQrcode() {
      this.qrLoading = true
      this.qrInfo.qrcode = ''
      this.qrInfo.qrcodeError = ''
      try {
        const res = await axiosconf.applicationJsonGet('/mall/admin/invite/qrcode', {
          inviteCode: this.qrInfo.inviteCode,
          envVersion: this.qrInfo.envVersion
        })
        if (res.data && res.data.code === 0) {
          const data = res.data.data || {}
          this.qrInfo.qrcode = data.qrcode || ''
          this.qrInfo.qrcodeError = data.qrcodeError || ''
        } else {
          this.qrInfo.qrcodeError = (res.data && res.data.msg) || '获取二维码失败'
        }
      } catch (e) {
        console.error('查询二维码失败', e)
        this.qrInfo.qrcodeError = '获取二维码失败'
      } finally {
        this.qrLoading = false
      }
    },
    copyCode(code) {
      if (!code) return
      const ta = document.createElement('textarea')
      ta.value = code
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        this.$message.success('邀请码已复制')
      } catch (e) {
        this.$message.error('复制失败')
      } finally {
        document.body.removeChild(ta)
      }
    },
    downloadQr() {
      if (!this.qrInfo.qrcode) return
      const a = document.createElement('a')
      a.href = this.qrInfo.qrcode
      a.download = `mall-invite-${this.qrInfo.inviteCode || 'qrcode'}.png`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
}
</script>

<style scoped>
.independent-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.content { padding: 20px; }
.title {
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}
.title .border {
  display: inline-block;
  width: 3px;
  height: 14px;
  background: #679FF6;
  margin-right: 8px;
  vertical-align: middle;
}

.form-card {
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
}
.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.form-row:last-child { margin-bottom: 0; }
.form-label {
  font-size: 14px;
  color: #606266;
  margin: 0 10px 0 0;
}
.form-row .el-input + .form-label {
  margin-left: 24px;
}
.form-row .el-select + .form-label {
  margin-left: 24px;
}
.form-tip {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
}
.form-tip b {
  color: #606266;
  font-weight: 600;
}
.qr-env-tip {
  font-size: 12px;
  color: #909399;
}

.editor {
  color: #679FF6;
  cursor: pointer;
  margin-right: 12px;
}
.editor:hover { text-decoration: underline; }

.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}

/* 弹窗 */
.qr-modal {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: stretch;
}
.qr-row {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
}
.qr-label {
  width: 70px;
  color: #909399;
}
.qr-code {
  font-family: monospace;
  font-size: 16px;
  color: #1D7268;
  font-weight: 600;
  cursor: pointer;
}
.qr-code:hover { text-decoration: underline; }
.qr-img-wrap {
  display: flex;
  justify-content: center;
  margin: 12px 0;
}
.qr-img {
  width: 240px;
  height: 240px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
}
.qr-placeholder {
  width: 240px;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  color: #909399;
  font-size: 13px;
  text-align: center;
  padding: 0 16px;
  box-sizing: border-box;
}
.qr-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 8px;
}
.qr-error-tip {
  margin-top: 8px;
  padding: 8px 12px;
  background: #fef0f0;
  color: #f56c6c;
  font-size: 12px;
  border-radius: 4px;
  word-break: break-all;
}
</style>
